import { createIconSetFromIcoMoon } from "@expo/vector-icons";

const MigrateIcon = createIconSetFromIcoMoon(
  require("app/assets/migrate-icon/selection.json"),
  "Migrate Icon",
  "/fonts/Migrate-Icon.ttf"
);

export { MigrateIcon };
